<template>
  <v-col class="no-bottom-pad">
    <v-card flat tile>
      <v-img
        lazy-src="https://placehold.co/100x100"
        class="rounded"
        :style="background"
        :height="height"
        :max-width="width"
        :src="image"
        :alt="description"
      />
      <v-card-text v-if="withName" class="text-left">
        {{ description }}
        <p><em>Gray background not intended to represent fabric color selection.</em></p>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<style scoped lang="scss">
  .v-card__text {
    padding: 10px 20px 0 0 !important;
    font-size: 13px;
  }
  .no-bottom-pad {
    padding-bottom: 0 !important;
  }
</style>

<script>
import { getDiamondQuiltOption } from '@/utils'
import { mapState } from 'vuex'

export default {
  props: {
    position: String,
    small: Boolean,
    withName: Boolean,
  },
  computed: {
    ...mapState([
      'variations'
    ]),
    quilt() {
      return getDiamondQuiltOption(this.variations[this.position])
    },
    width: function() {
      return this.small ? '100%' : 200
    },
    height: function() {
      return this.small ? 75 : 100
    },
    color: function() {
      return this.quilt ? this.quilt.color : null
    },
    style: function() {
      return this.quilt ? this.quilt.style : null
    },
    image: function() {
      return this.style ? this.style.image : 'https://placehold.co/100x100?text=Horizontal Quilting ($0)'
    },
    background: function() {
      return this.color ? `background-color: #${this.color.hex}` : 'unset'
    },
    description() {
    if (!this.style?.name) return 'None';

    const colorName = this.style.name === 'Diamond' ? 'matching' : this.color?.name;

    return colorName ? `${this.style.name} with ${colorName} stitching` : 'None';
  }
  }
}
</script>
